import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';


const isEmailString = function(strn) {
  // For historical consistency we use a custom email regex rather than zfutils
  return !!strn.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);     
};


const getESQuery = function(navState){
  const isInRootFolder = isNil(navState.get('folder_id'));

  return {
    queryParams: {
      sort_by: navState.get('sort_by'),
      types: getESQueryCurrentMediaTypes(navState).join(','),
      ...getESQueryPartialFromSearchText(navState.getTextSearch()),
      // If navState's `folder_id` is somehow `undefined`, it is important that we change it to `null`
      // so that it shows up in the query so that the default is the main folder.
      parent_folder_id: (
        navState.getIsSearching() && isInRootFolder ?
          undefined
        :
          navState.get('folder_id') || null
      )
    }
  };
};
    
const getESQueryCurrentMediaTypes = function(navState) {
  return isEmpty(navState.get('media_types_search')) ?
      // For historical compatibility we choose to not use "all" and instead use all
      // known media types
      navState.getEnabledMediaTypes()
    :
      navState.get('media_types_search');
};

/*
 * It is possible to do advanced searches where, for example, you search the media library
 * by an asset's URL id. This makes it possible to link to a specific asset or set of assets
 * in the ML easily. 
 * 
 * As an example, a search for a specific asset would be the following: 
 * [asset_id=18eae3f873b1535]
 * 
 * These types of queries are recognized and parsed into key-value pairs that are sent to the 
 * search api for handling. Currently the two keys that this is best suited for are asset_id
 * and submitter (which can be either a name or an email). 
 *
 * To enable support for new types of special searches, simply ammend the search api to handle
 * the new keys when it constructs the ES search json object. 
 */ 
const getESQueryPartialFromSearchText = function(searchText) {
  var specialSearch = searchText.match(/\[.*?\]/g);
  var plainSearch = searchText.replace(/\[.*?\]/g, '').trim(); 
  var queryDict = [];
  
  forEach(specialSearch, (match)=> {
    var specialQueryItem = match.replace(/[\[\]]/g, '');
    var splitItem = specialQueryItem.split('=');
    queryDict[splitItem[0]] = splitItem[1];
  }); 
  if (isEmailString(plainSearch)) {
    queryDict['submitter_email'] = plainSearch;
  } else {
    queryDict['query'] = plainSearch;
  }
  return queryDict;
};


export default getESQuery;
